module.exports = __webpack_public_path__ + "img/client-dashboard.adb3f83d.png";